import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { api, mediaUrl } from "@/lib/api";

const SettingsContext = createContext({ settings: {}, categories: [], catName: (s) => s, refresh: () => {}, refreshCategories: () => {} });

const applyFavicon = (url) => {
  if (!url) return;
  const link = document.querySelector("link[rel~='icon']") || Object.assign(document.createElement("link"), { rel: "icon" });
  link.href = mediaUrl(url);
  document.head.appendChild(link);
};

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState({});
  const [categories, setCategories] = useState([]);
  const refresh = useCallback(() => api.get("/settings").then((r) => setSettings(r.data)).catch((error) => console.error("Settings error:", error)), []);
  const refreshCategories = useCallback(() => api.get("/categories").then((r) => setCategories(r.data)).catch((error) => console.error("Categories error:", error)), []);

  useEffect(() => { refresh(); refreshCategories(); }, [refresh, refreshCategories]);
  useEffect(() => { applyFavicon(settings.favicon_url); }, [settings.favicon_url]);
  useEffect(() => { document.title = settings.site_name || "Chronique.cd"; }, [settings.site_name]);

  const value = useMemo(() => {
    const map = Object.fromEntries(categories.map((c) => [c.slug, c.name]));
    return {
      settings,
      categories,
      navCategories: categories.filter((c) => c.slug !== "chronique"),
      catName: (slug) => map[slug] || slug,
      refresh,
      refreshCategories,
    };
  }, [settings, categories, refresh, refreshCategories]);

  return <SettingsContext.Provider value={value}>{children}</SettingsContext.Provider>;
};

export const useSettings = () => useContext(SettingsContext);
